import { render, staticRenderFns } from "./PropertyCommon.vue?vue&type=template&id=0137c42b&scoped=true&"
import script from "./PropertyCommon.vue?vue&type=script&lang=js&"
export * from "./PropertyCommon.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCommon.vue?vue&type=style&index=0&id=0137c42b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137c42b",
  null
  
)

export default component.exports